export const content =
    "Sreekesh Iyer is a Software Engineer and Content Writer from Mumbai, India. He loves working with Web Development, AWS Cloud and DevOps technologies. He is passionate about tech and loves talking to people about tech and communities";
export const keywords = "Sreekesh Iyer, Sreekesh, Iyer, Portfolio, Website";
export const og_title = "Sreekesh Iyer's Portfolio";
export const og_image =
    "https://res.cloudinary.com/zenon-cloudinary/image/upload/v1690317180/OGIMG_kt2kir.png";
export const author = "Sreekesh Iyer";
